/**
 * @module use-cases/combo/actions
 * @desc Combo Action Creators
 *
 */

import { createAction, createAsyncAction } from 'core/use-cases/utilities';

import type { Cart, Combo, SelectedComboItem } from 'core/domains';

export const comboCleanUp = createAction<'comboCleanUp'>('comboCleanUp');

export const comboFetch = createAsyncAction<'comboFetch', undefined, Combo['data']>('comboFetch');

export const comboRedirect = createAction<'comboRedirect', string>('comboRedirect');

export const comboUpdate = createAction<'comboUpdate', number>('comboUpdate');

export const comboItemUpdate = createAction<'comboItemUpdate', SelectedComboItem>(
  'comboItemUpdate',
);
export const comboPost = createAsyncAction<'comboPost', Combo['data'], Cart['data']>('comboPost');
